import { render, staticRenderFns } from "./InfoPromotions.vue?vue&type=template&id=81e1f2fa&scoped=true&"
import script from "./InfoPromotions.vue?vue&type=script&lang=js&"
export * from "./InfoPromotions.vue?vue&type=script&lang=js&"
import style0 from "./InfoPromotions.vue?vue&type=style&index=0&id=81e1f2fa&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "81e1f2fa",
  null
  
)

export default component.exports